// SEO utility functions

export const generateSlug = (title: string): string => {
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single
    .trim();
};

export const calculateReadingTime = (content: string): number => {
  const wordsPerMinute = 200;
  const words = content.split(/\s+/).length;
  return Math.ceil(words / wordsPerMinute);
};

export const extractPlainText = (html: string): string => {
  return html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
};

export const generateMetaDescription = (content: string, maxLength: number = 160): string => {
  const plainText = extractPlainText(content);
  if (plainText.length <= maxLength) return plainText;
  
  return plainText.substring(0, maxLength - 3).trim() + '...';
};

export const generateKeywords = (title: string, content: string, tags: string[]): string[] => {
  const commonWords = ['the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by', 'is', 'are', 'was', 'were', 'be', 'been', 'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would', 'could', 'should', 'may', 'might', 'must', 'can', 'a', 'an', 'this', 'that', 'these', 'those'];
  
  const titleWords = title.toLowerCase().split(/\s+/).filter(word => 
    word.length > 3 && !commonWords.includes(word)
  );
  
  const contentWords = extractPlainText(content).toLowerCase()
    .split(/\s+/)
    .filter(word => word.length > 4 && !commonWords.includes(word))
    .slice(0, 10);
  
  return [...tags, ...titleWords, ...contentWords].slice(0, 15);
};